// src/components/store/sections/hero-banner/HeroV40MagazinecoverRoyalViolet.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV40MagazinecoverRoyalViolet(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={40}
      archKey="magazine_cover"
      archLabel="Luxury Magazine Cover"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      {...props}
    />
  );
}
